import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MovementService } from '../../../services/movement.service';
import { HouseFlatCredit } from '../../../models/house-flat-credit.model';

@Component({
  selector: 'app-movements-credits-page',
  templateUrl: './movements-credits-page.component.html',
  styleUrl: './movements-credits-page.component.scss'
})
export class MovementsCreditsPageComponent {

  public neighborhoodId: string = '';

  public loading: boolean = true;
  public houses: HouseFlatCredit[] = [];
  public totalCreditBalance: number = 0;
  public housesWithCredit: number = 0;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private movementService: MovementService,
  ) {

    this.activatedRoute.params.subscribe(
      async params => {
        this.neighborhoodId = params['neighborhoodId'];
        await this.getCredits();
      }
    );

  }

  /*
   ██████╗ ███████╗████████╗ ██████╗██████╗ ███████╗██████╗ ██╗████████╗███████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝██╔══██╗██║╚══██╔══╝██╔════╝
  ██║  ███╗█████╗     ██║   ██║     ██████╔╝█████╗  ██║  ██║██║   ██║   ███████╗
  ██║   ██║██╔══╝     ██║   ██║     ██╔══██╗██╔══╝  ██║  ██║██║   ██║   ╚════██║
  ╚██████╔╝███████╗   ██║   ╚██████╗██║  ██║███████╗██████╔╝██║   ██║   ███████║
   ╚═════╝ ╚══════╝   ╚═╝    ╚═════╝╚═╝  ╚═╝╚══════╝╚═════╝ ╚═╝   ╚═╝   ╚══════╝

  */
  // region getCredits
  async getCredits() {

    this.loading = true;

    const detail = await this.movementService.getCredits(
      this.neighborhoodId
    );

    if(detail) {
      this.houses = detail.houses;
      this.totalCreditBalance = detail.totalCreditBalance;
      this.housesWithCredit = detail.housesWithCredit;
    }

    this.loading = false;

  }

  /*
   ██████╗  ██████╗   ████████╗ ██████╗
  ██╔════╝ ██╔═══██╗  ╚══██╔══╝██╔═══██╗
  ██║  ███╗██║   ██║     ██║   ██║   ██║
  ██║   ██║██║   ██║     ██║   ██║   ██║
  ╚██████╔╝╚██████╔╝     ██║   ╚██████╔╝
   ╚═════╝  ╚═════╝      ╚═╝    ╚═════╝

  */
  // region goToHouseFlatPayments
  goToHouseFlatPayments(
    house: HouseFlatCredit,
    event?: Event,
  ) {

    /* Solo llega evento desde los atajos de teclado de la fila. El clic del
       mouse no lo manda porque cualquier celda es un origen valido. */
    if(event) {

      /* Enter y Espacio disparados sobre elementos internos burbujean hasta el
         <tr>: si el evento no nacio en la fila misma, la accion le pertenece a
         ese elemento y la fila no debe navegar. */
      if(event.target !== event.currentTarget) {
        return;
      }

      /* Evita que la barra espaciadora haga scroll de la pagina al activar. */
      event.preventDefault();

    }

    this.router.navigate(
      [
        '/neighborhoods',
        this.neighborhoodId,
        'streets-buildings',
        house.streetBuildingId,
        'houses-flats',
        house.houseFlatId,
        'payments'
      ]
    );

  }

}
